import React from 'react';

export default function CatalogGridSkeleton({ count = 8 }) {
  return (
    <div className="product-grid catalog-skeleton" aria-busy="true" aria-label="Loading products">
      {Array.from({ length: count }, (_, i) => (
        <div key={i} className="product-card catalog-skeleton__card">
          <div className="catalog-skeleton__media" />
          <div className="catalog-skeleton__line catalog-skeleton__line--title" />
          <div className="catalog-skeleton__line catalog-skeleton__line--short" />
        </div>
      ))}
    </div>
  );
}
